var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarklogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 2.25C3.3375 2.25 2.98425 2.397 2.69025 2.691C2.39625 2.985 2.2495 3.338 2.25 3.75L2.25 14.25C2.25 14.6625 2.397 15.0157 2.691 15.3097C2.985 15.6037 3.338 15.7505 3.75 15.75H9V14.25H3.75L3.75 3.75H9V2.25H3.75ZM12 5.25L10.9688 6.3375L12.8813 8.25H6.75V9.75H12.8813L10.9688 11.6625L12 12.75L15.75 9L12 5.25Z",
    fill: "#1B1C57"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarklogout);
export default __webpack_public_path__ + "static/media/darklogout.0bed20e8e6f73f545e9008b1f6f1f078.svg";
export { ForwardRef as ReactComponent };